import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './IndustryPillars.module.css';

const images = [
    {
        src: '/images/automotive_hero.png',
        webp: '/images/automotive_hero-800.webp 800w, /images/automotive_hero-1600.webp 1600w',
    },
    {
        src: '/images/energie_hero_v2.png',
        webp: '/images/energie_hero_v2-800.webp 800w, /images/energie_hero_v2-1600.webp 1600w',
    },
    {
        src: '/images/logistik_hero.png',
        webp: '/images/logistik_hero-800.webp 800w, /images/logistik_hero-1600.webp 1600w',
    },
    {
        src: '/images/fintech_hero.png',
        webp: '/images/fintech_hero-800.webp 800w, /images/fintech_hero-1600.webp 1600w',
    },
    {
        src: '/images/fertigung_hero.png',
        webp: '/images/fertigung_hero-800.webp 800w, /images/fertigung_hero-1600.webp 1600w',
    },
];

export const IndustryPillars: React.FC = () => {
    const { t, language } = useLanguage();

    const pillarsData = t.industriesPage.pillars;

    const pillars = [
        { ...pillarsData.automotive, link: '/industries/automotive' },
        { ...pillarsData.energy, link: '/industries/energie-renewables' },
        { ...pillarsData.logistics, link: '/industries/logistik-warehousing' },
        { ...pillarsData.fintech, link: '/industries/fintech' },
        { ...pillarsData.manufacturing, link: '/industries/fertigung-iiot' },
    ];

    const learnMoreText = language === 'en' ? 'Explore Industry' : 'Branche erkunden';

    return (
        <section className={styles.pillars}>
            <div className={styles.pillars__container}>
                <div className={styles.pillars__grid}>
                    {pillars.map((pillar, index) => {
                        const image = images[index] ?? images[0];
                        const imageClassName =
                            index === 1
                                ? `${styles.pillars__image} ${styles['pillars__image--energy']}`
                                : styles.pillars__image;
                        return (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: '-50px' }}
                                transition={{ duration: 0.3, delay: index * 0.05 }}
                            >
                                <Link to={pillar.link} className={styles.pillars__card}>
                                    <div className={styles.pillars__imageWrapper}>
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={image.webp}
                                            sizes="(max-width: 768px) 100vw, 260px"
                                        />
                                        <img
                                            src={image.src}
                                            alt={pillar.title}
                                            className={imageClassName}
                                            loading="lazy"
                                        />
                                    </picture>
                                    </div>
                                    <h3 className={styles.pillars__title}>{pillar.title}</h3>
                                    <ul className={styles.pillars__list}>
                                        {pillar.items.map((item: string, i: number) => (
                                            <li key={i} className={styles.pillars__item}>
                                                <span className={styles.pillars__bullet}>•</span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                    <span className={styles.pillars__link}>
                                        {learnMoreText} <ArrowRight size={16} />
                                    </span>
                                </Link>
                            </motion.div>
                        );
                    })}
                </div >
            </div >
        </section >
    );
};
